module.exports = __webpack_public_path__ + "img/15.58a21717.jpg";